<template>
  <div id="editorial-office-submissions-corespondence-record">
    <div class="ipub-h2 mar-b-12">
      Correspondence Record for Manuscript No.: {{articleDetail.code}}
    </div>
    <div class="ipub-p1 mar-b-20">{{articleDetail.title}}</div>

    <div class="ipub-list-tab">
      <a v-for="item in articleDetail.signList"
         :key="'sign'+item"
         @click="onSignChange(item)"
         :class="['ipub-list-tab--status', params.sign === item ? 'active' : '']">Version {{item}}</a>
      <!-- <a v-for="(item, key) in STATUS"
         :key="key"
         @click="changeStatus(key)"
         :class="['ipub-list-tab--status mar-l-40',params.status===key?'active':'']">{{item}} ({{countObj[key] || 0}})</a> -->
    </div>
    <div class="ipub-filter-div">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="[12,16]">
          <ipub-col :span="6">
            <ipub-input v-model.trim="params.keyword"
                        placeholder="Search by recipient's name / email" />
          </ipub-col>
          <ipub-col :span="6">
            <site-search-group v-model.trim="params.subject"
                               placeholder="Search by letter title"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <template v-if="showAdv">
          <div class="flex">
            <span class="line-h-40 ipub-p2 fw-bd nowrap">Correspondence Time</span>
            <ipub-date-range-picker class="mar-l-12"
                                    style="width: 500px"
                                    :placeholder="['From','To']"
                                    @change="handleDateChange"
                                    v-model="date" />
          </div>
        </template>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showAdv = !showAdv}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:title="{record, text}">
          <a @click="openRecord(record)"
             class="omis link-color">{{text}}</a>
        </template>
        <!-- <template v-slot:status="{text}">
          {{ARTICLE_STATUS[text]}}
        </template> -->
        <template v-slot:status="{text}">
          <div v-if="text==='FAILED'"
               class="key-color">{{EMAILSTATUS[text]}}</div>
          <div v-else-if="text==='DELIVERED'"
               class="success-color">{{EMAILSTATUS[text]}}</div>
          <div v-else>{{EMAILSTATUS[text]}}</div>
        </template>
        <template v-slot:event="{ text }">
          <span>{{EMAILEVENT[text]}}</span>
        </template>
        <template v-slot:emails="{text}">
          <ipub-tooltip style="width:100%"
                        v-if="text"
                        omis="omis"
                        :label="text.split(',').join(', ')"
                        placement="bottomLeft">
            {{text}}
          </ipub-tooltip>
          <template v-else>- -</template>
        </template>
      </ipub-table>
    </div>
    <Detail :isVisable="show"
            :id="inputData.id"
            @cancel="cancel" />
    <!--             :inputData="inputData"
 -->
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
